export const ApplyGiftNoteStyles = () => {
  const cssText = `
      p,
      button,
      label,
      input,
      textarea {
        font-family: "Avenir" !important;
      }
    
      #save-button,
      button.active {
        background-color: #00b0be !important;
        cursor: pointer;
      }
      #method {
        border: 1px solid #00b0be !important;
      }
      #form {
        border-top: 1px solid #00b0be !important;
      }
      #content form,
      #content form *:focus,
      #content form *:focus-within:not(#methods) {
        --tw-ring-color: #00b0be !important;
        border-color: #00b0be !important;
      }

      #close-button {
        cursor: pointer;
      }

      #close-button, #close-button svg {
        color: #00b0be !important;
      }

      #remove-button {
        color: #00b0be !important;
        cursor: pointer;
      }
      #remove-button:hover {
        background-color: #00b0be !important;
        color: white !important;
      }

      #content .error,
      #content .medium-error,
      #content .required,
      #content .invalid {
        --tw-ring-color: #d7696d !important;
        border-color: #d7696d !important;
      }
      .text-red-500 {
        color: #d7696d !important;
      }
  `;

  const addButtonCssText = `
    #button:hover{
      background-color: #006375 !important;
      color: #CFEBED !important;
    }
    #button {
      text-align: left !important;
      padding-top: 12px !important;
      padding-bottom: 12px !important;
      font-size: 14px !important;
      border: 1px solid #00b0be !important;
    }
  `;

    setTimeout(() => {
    const elems = document.querySelectorAll("giftnote-core");
    const buttonElements = document.querySelectorAll("giftnote-button");
    buttonElements.forEach(buttonElement => {
      if (!buttonElement.shadowRoot) return;
      // Prevent multiple style injections
      if (!buttonElement.shadowRoot.querySelector('style[data-custom-style="giftnote-button"]')) {
        const buttonStyle = document.createElement("style");
        buttonStyle.setAttribute("data-custom-style", "giftnote-button");
        buttonStyle.textContent = addButtonCssText;
        buttonElement.shadowRoot.appendChild(buttonStyle);
      }
    });
    elems.forEach(elem => {
      if (!elem.shadowRoot) return;
      // Prevent multiple style injections
      if (!elem.shadowRoot.querySelector('style[data-custom-style="giftnote-core"]')) {
        const newStyle = document.createElement("style");
        newStyle.setAttribute("data-custom-style", "giftnote-core");
        newStyle.textContent = cssText;
        elem.shadowRoot.appendChild(newStyle);
      }
    });
  }, 1500);
}
